import { formatNumber } from './utils/format-number'

export default class TickerData {
  static isBrutto = false

  static init () {
    const date = new Date()
    const url = `${window.location.origin}/?type=9998`
    // eslint-disable-next-line max-len
    const newUrl = `${url}&tx_voltegoprice_price[day]=${date.getDate()}&tx_voltegoprice_price[month]=${date.getMonth() + 1}&tx_voltegoprice_price[year]=${date.getFullYear()}`

    fetch(newUrl)
      .then((response) => response.json())
      // eslint-disable-next-line no-console
      .catch((error) => console.error(`EPEX-Preise konnten nicht geladen werden: ${error}`))
      .then((res) => {
        const bruttoDataset = []
        const nettoDataset = []

        res[0].prices.forEach(price => {
          bruttoDataset.push(price.priceAmount * 1.19)
          nettoDataset.push(price.priceAmount)

          if (date.getHours() === price.priceHour) {
            if (TickerData.isBrutto) {
              TickerData.putCurrentValue(price.priceAmount * 1.19)
            }
            else {
              TickerData.putCurrentValue(price.priceAmount)
            }
          }
        })

        TickerData.putMaxValue(TickerData.isBrutto, nettoDataset, bruttoDataset)
        TickerData.putMinValue(TickerData.isBrutto, nettoDataset, bruttoDataset)
      })
  }

  // Output the highest value of the array in given selector
  static putMaxValue (isBrutto, nettoDataset, bruttoDataset) {
    const maxValue = Math.max.apply(Math, !isBrutto ? nettoDataset : bruttoDataset)
    const selectors = document.getElementsByClassName('ticker-highest-price')

    Object.keys(selectors).map(key => {
      selectors[key].innerHTML = formatNumber(maxValue)
    })
  }

  // Output the lowest value of the array in given selector
  static putMinValue (isBrutto, nettoDataset, bruttoDataset) {
    const minValue = Math.min.apply(Math, !isBrutto ? nettoDataset : bruttoDataset)
    const selectors = document.getElementsByClassName('ticker-lowest-price')

    Object.keys(selectors).map(key => {
      selectors[key].innerHTML = formatNumber(minValue)
    })
  }

  // Output the value of the current hour in the array in given selector
  static putCurrentValue (value) {
    const selectors = document.getElementsByClassName('ticker-price-per-hour')

    Object.keys(selectors).map(key => {
      selectors[key].innerHTML = formatNumber(value)
    })
  }
}
